module.exports = __webpack_public_path__ + "static/DragDrop-073825645f62bef4577c73e7dc0ab489.mp4";